package io.horion.cv.components.preview

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

fun extractYear(dateStr: String): String {
    if (dateStr.isBlank()) return ""
    val match = Regex("\\d{4}").find(dateStr)
    return match?.value ?: dateStr
}

fun formatPeriod(start: String, end: String): String {
    val startYear = extractYear(start)
    val endYear   = extractYear(end)
    return if (endYear.isNotBlank() && endYear != startYear) "$startYear - $endYear" else startYear
}

@Composable
fun HtmlBlock(html: String, styleBlock: StyleScope.() -> Unit = {}) {
    if (html.isBlank()) return
    Div(attrs = { style {
        property("overflow-wrap", "break-word")
        styleBlock()
    }}) {
        DisposableEffect(html) {
            val element = scopeElement // This is your raw DOM element
            element.innerHTML = html

            onDispose {
                // Clean up resources, event listeners, or timers here
            }
        }
    }
}

@Composable
fun HtmlInline(html: String, styleBlock: StyleScope.() -> Unit = {}) {
    if (html.isBlank()) return
    Span(attrs = { style {
        property("overflow-wrap", "break-word")
        property("min-width", "0")
        styleBlock()
    }}) {
        DisposableEffect(html) {
            val element = scopeElement // This is your raw DOM element
            element.innerHTML = html

            onDispose {
                // Clean up resources, event listeners, or timers here
            }
        }
    }
}